import type { CategorySales } from '@/domain/entities/category-sales.entity'
import type { KpiMetric } from '@/domain/entities/metric.entity'
import type { Order } from '@/domain/entities/order.entity'
import type { OutletSales } from '@/domain/entities/outlet-sales.entity'
import type { RevenuePoint } from '@/domain/entities/revenue.entity'
import type {
  DashboardFilter,
  DashboardOverview,
  DashboardRepository,
  DateRange,
} from '@/domain/repositories/dashboard.repository'
import { dashboardFixtures } from './dashboard.fixtures'
import { dashboardMapper } from './dashboard.mapper'

/** Simulasi latency jaringan supaya loading/skeleton state terlihat. */
function delay<T>(value: T, ms = 450): Promise<T> {
  return new Promise((resolve) => setTimeout(() => resolve(value), ms))
}

/**
 * Adapter mock — implementasi DashboardRepository tanpa backend.
 * Dipakai saat VITE_API_BASE_URL kosong (mode demo/dev).
 */
export class DashboardMockRepository implements DashboardRepository {
  async getOverview(filter: DashboardFilter): Promise<DashboardOverview> {
    return delay(dashboardMapper.toOverview(dashboardFixtures.overview(filter)))
  }

  async getMetrics(range: DateRange): Promise<KpiMetric[]> {
    return delay(dashboardFixtures.metrics(range).map(dashboardMapper.toMetric))
  }

  async getRevenueSeries(range: DateRange): Promise<RevenuePoint[]> {
    return delay(dashboardFixtures.revenueSeries(range).map(dashboardMapper.toRevenuePoint))
  }

  async getCategorySales(range: DateRange): Promise<CategorySales[]> {
    return delay(dashboardFixtures.categorySales(range).map(dashboardMapper.toCategorySales))
  }

  async getSalesByOutlet(range: DateRange): Promise<OutletSales[]> {
    return delay(dashboardFixtures.salesByOutlet(range).map(dashboardMapper.toOutletSales))
  }

  async getRecentOrders(range: DateRange): Promise<Order[]> {
    return delay(dashboardFixtures.recentOrders(range).map(dashboardMapper.toOrder))
  }
}
